export default {
  methods: {
    loader() {
      return this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
          onCancel: this.onCancel,
      });
    }
  }
}